import { render, staticRenderFns } from "./goods-tabs.vue?vue&type=template&id=a86f3bd0&scoped=true&"
import script from "./goods-tabs.vue?vue&type=script&lang=js&"
export * from "./goods-tabs.vue?vue&type=script&lang=js&"
import style0 from "./goods-tabs.vue?vue&type=style&index=0&id=a86f3bd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86f3bd0",
  null
  
)

export default component.exports